<template>
  <div class="p-4">
    <h4>{{ chartRoute.title }}</h4>
    <p>The 2.9 terabyte leak contains a total of more than 11.9 million files.</p>
    <stacked-bar-chart
      :data="$options.tsv"
      :social-mode="socialMode"
      :social-mode-ratio="0.75"
      :fixed-height="fixedHeight"
      hide-legend
      x-axis-tick-format="," />
    <p class="text-muted mt-2 small text-right">Source: Pandora Papers data</p>
    <p class="mt-2 font-italic">*More than 4 million PDFs, more than 1.79 million Word documents, and other document formats.</p>
  </div>
</template>

<script>
import chart from '../mixins/chart'

export default {
  mixins: [chart],
  name: 'ChartDocumentTypes'
}
</script>

<tsv>
label	value
Documents*	6406119.00
Images	2937513.00
Emails	1205716.00
Spreadsheets	467405.00
Presentations	8511.00
Audios	3497.00
Videos	1421.00
Others	873494.00
</tsv>

<style lang="scss" scoped>
.stacked-bar-chart {
  & /deep/ &__groups__item__label {
    white-space: nowrap;
    min-width: 115px;
  }
}
</style>
